var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8785 11.6315L5.37607 3.9942C5.37607 3.9942 5.36171 3.9942 5.35453 3.9942H1.10537C1.10537 3.9942 1.09101 3.9942 1.08383 3.9942L0.574219 11.6978H5.78519L5.87132 11.6315H5.8785Z",
    fill: "#15A9AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1104 0H3.48108H2.97864H1.34931L1.11963 3.43117H5.34008L5.1104 0Z",
    fill: "#15A9AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7865 12.2343C20.6788 12.188 20.607 12.0886 20.607 11.976V6.72989L13.7237 12.188C13.6304 12.2608 13.5083 12.2807 13.3935 12.2277C13.2858 12.1813 13.214 12.082 13.214 11.9694V6.71002L6.09382 12.188C6.0364 12.2277 5.9718 12.2542 5.90003 12.2542H0V24.7005H28V6.72327L21.1166 12.1813C21.0233 12.2542 20.9013 12.2741 20.7865 12.2211V12.2343ZM8.76391 19.6928H5.6201V15.1753H8.76391V19.6928ZM15.9846 19.6928H12.8408V15.1753H15.9846V19.6928ZM23.2053 19.6928H20.0615V15.1753H23.2053V19.6928Z",
    fill: "#075255"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 15.1754H12.8406V19.6928H15.9844V15.1754Z",
    fill: "#15A9AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2055 15.1754H20.0616V19.6928H23.2055V15.1754Z",
    fill: "#15A9AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76405 15.1754H5.62024V19.6928H8.76405V15.1754Z",
    fill: "#15A9AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDo);
export default __webpack_public_path__ + "static/media/ic_do.ec4ea3fdbc6defce14c5ba4adaa6b704.svg";
export { ForwardRef as ReactComponent };